module.exports = __webpack_public_path__ + "img/dot.f89b848e.svg";